module.exports = __webpack_public_path__ + "img/price-settings-desktop-fr.99bec07f.jpg";